import Component from '../../shared/component';

export default class MentorMessageForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$sourceField = this.$element.find('.mentorshipRequest-messageSource');

    this.bindEvents();
  }

  bindEvents() {
    this.handleModalShown = this.handleModalShown.bind(this);

    this.$element.on('shown.bs.modal.MentorMessageForm', this.handleModalShown);
  }

  unbindEvents() {
    this.$element.off(
      'shown.bs.modal.MentorMessageForm',
      this.handleModalShown
    );
  }

  handleModalShown(event) {
    const $target = $(event.relatedTarget);
    if (!$target) return;

    this.$sourceField.val($target.data('trackable-source'));
  }
}
